export default "__VITE_ASSET__CG2PSvKr__"